<div
  class="add-extra"
  [class.accept]="isReadonly && !isDisabled && isLoaded"
  [class.loading]="!isLoaded"
  [class.disabled]="isDisabled"
>
  <div>
    <app-checkbox
      (checked)="onChecked($event)"
      [isReadonly]="isReadonly"
      [isChecked]="isChecked"
      *ngIf="!isDisabled && isLoaded"
    >
      <ng-content select="[text]"></ng-content>
    </app-checkbox>

    <div *ngIf="isDisabled || !isLoaded" class="add-extra__disabled">
      <i class="fa-regular fa-exclamation-circle"></i>
      <p class="ml-2">
        <strong>
          <ng-content select="[disabled-text]"></ng-content>
        </strong>
      </p>
    </div>
  </div>

  <div class="add-extra__value text--right" *ngIf="!isDisabled || !isLoaded">
    <p class="margin--none">
      <ng-content select="[value]"></ng-content>
    </p>
    <p class="disabled toggle margin--none" *ngIf="isDisabled"></p>
  </div>
</div>

<app-content-module
  class="help-disabled"
  *ngIf="isOpen || isDisabled"
  [@slideInOut]
>
  <ng-content></ng-content>
</app-content-module>

<!-- show when checkbox is selected -->
<app-content-module class="help" *ngIf="hasHint && isChecked" [@slideInOut]>
  <ng-content select="[hintText]"></ng-content>
</app-content-module>
